module.exports = __webpack_public_path__ + "img/kontakt_960.3afc98e0.png";